import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { LuTrash2 as LuRemove, LuFolderCheck as LuIngest, LuSquareCheck, LuUser, LuSearch, LuTextSearch as LuSearchResults} from "react-icons/lu"
import { Alert, Code, Table, Heading, Stack, Box, SegmentGroup, HStack, Text, Textarea, Field,Flex, Spacer, Input, Select, createListCollection, Portal, Button} from '@chakra-ui/react';
import PageTitle from 'components/ui/PageTitle';
import PageContent from 'components/ui/PageContent';
import JobStatus from 'components/ui/JobStatus';

function IngestOverviewPage() {
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState(null);
  const [directoryPath, setDirectoryPath] = useState('');
  const [ingestMessage, setIngestMessage] = useState('');
  const [isIngestLoading, setIsIngestLoading] = useState(false);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('/api/ingestion_status');
        setJobs(response.data);
      } catch (err) {
        console.error('Error fetching jobs', err);
        setError(err.message);
      }
    };

    fetchJobs();
  }, []);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleIngestJob = async () => {
    if (!directoryPath.trim()) {
      setIngestMessage('Error: Directory path cannot be empty');
      return;
    }
    
    setIsIngestLoading(true);
    setIngestMessage('');
    
    try {
      const response = await axios.post(`/api/ingest_job/${directoryPath}`);
      setIngestMessage(`Ingest job submitted successfully for: ${directoryPath}`);
      setDirectoryPath(''); // Clear the input field
    } catch (err) {
      console.error('Error submitting ingest job', err);
      setIngestMessage(`Error: ${err.response?.data?.detail || err.message}`);
    } finally {
      setIsIngestLoading(false);
    }
  };

  const handleDelete = async (e, job) => {
    e.stopPropagation(); // Prevent row click navigation

    if (!window.confirm(`Are you sure you want to delete ${job.name}?`)) {
        return;
    }
    try {

      // Remove the deleted job from the state
      setJobs(jobs.filter(j => j.id !== job.id));

      await axios.delete(
        `api/ingestion_error/${job.id}`,
      )
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
    } catch (err) {
      console.error('Error deleting job', err);
    }
  };

  return (
  <PageContent>
      <PageTitle icon={LuIngest} title="Ingestion Status" />

      {/* <VStack > */}
        <HStack>
          <Field.Root>
            <HStack >
              <Field.Label flex="auto 0 0">Ingest from directory:</Field.Label>
              <Input flex="auto 0 0"
                placeholder="Enter directory path" 
                value={directoryPath} 
                onChange={(e) => setDirectoryPath(e.target.value)}
              />
            </HStack>
          </Field.Root>
          {/* <Flex> */}
            <Button 
              onClick={handleIngestJob}
              isLoading={isIngestLoading}
              loadingText="Submitting"
              size="sm"
            >
              Submit Ingest Job
            </Button>
          {/* </Flex> */}
        </HStack>
        {ingestMessage && (
          <Alert.Root status={ingestMessage.startsWith('Error') ? 'error' : 'success'} >
            <Alert.Indicator />
            <Alert.Title>{ingestMessage}</Alert.Title>
          </Alert.Root>
        )}
      {/* </VStack> */}

      <Table.Root variant="line" stickyHeader striped  w="100%">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>ID</Table.ColumnHeader>
            <Table.ColumnHeader>Date</Table.ColumnHeader>
            <Table.ColumnHeader>Status</Table.ColumnHeader>
            <Table.ColumnHeader>Name</Table.ColumnHeader>
            {/* <Table.ColumnHeader>Project</Table.ColumnHeader> */}
            <Table.ColumnHeader>Metadata Filename</Table.ColumnHeader>
            <Table.ColumnHeader>Message</Table.ColumnHeader>
            <Table.ColumnHeader>Delete</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {jobs.map((job) => (
            <Table.Row key={job.id}>
              <Table.Cell>{job.id}</Table.Cell>
              <Table.Cell>{new Date(job.ingest_date+'Z').toLocaleString()}</Table.Cell>
              <Table.Cell><JobStatus status={job.status} /></Table.Cell>
              <Table.Cell>{job.name}</Table.Cell>
              {/* <Table.Cell>{job.project}</Table.Cell> */}
              <Table.Cell>
                <Box maxW="15em" maxH="10em" overflow="auto">
                  {/* {job.metadata_filename.substring(job.metadata_filename.indexOf("/") + 1)} */}
                  {job.metadata_filename}
                </Box>
              </Table.Cell>
              <Table.Cell>
                <Box maxW="30em" maxH="10em" overflow="auto" borderWidth="1px">
                  <Code variant="plain" >
                    <pre>{job.error_message}</pre>
                  </Code>
                </Box>
              </Table.Cell>
              <Table.Cell  pl="2em" py="0" pr="0">
                <Button variant="plain" size="md" maxH="2.2em" maxW="0.1em" color="red" _hover={{ bg: 'brand.subtle' }}
                  onClick={(e) => handleDelete(e, job)}
                  aria-label="Delete user"
                >
                  <LuRemove strokeWidth="2.2"/>
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

    </PageContent>
  );

  // return (
  //   <div style={{ margin: "2rem" }}>
  //     <h1>Ingestion Status</h1>
  //     <Link to="/">Go to Home</Link><br />
  //     <Link to="/search">Go to Search</Link>

  //     <table style={{ marginTop: "2rem", width: "100%" }}>
  //       <thead>
  //         <tr>
  //           <th>Date</th>
  //           <th>Status</th>
  //           <th>Name</th>
  //           <th>Project</th>
  //           <th>Metadata Filename</th>
  //           <th>Error Message</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {jobs.map((job) => (
  //           <tr key={job.id}>
  //             <td>{new Date(job.ingest_date+'Z').toLocaleString()}</td>
  //             <td>{job.status}</td>
  //             <td>{job.name}</td>
  //             <td>{job.project}</td>
  //             <td>{job.metadata_filename}</td>
  //             <td>{job.error_message}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>
  //   </div>
  // );
}

export default IngestOverviewPage;